<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="text-h5">
            Insufficient Permissions
          </v-card-title>
          <v-card-text>
            You do not have permission to create or edit schedules. Please contact your project administrator if this is incorrect.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
</script>
